<template>
  <b-sidebar
    v-model="toggle"
    width="80%"
    id="sidebar-right"
    title="Users"
    backdrop-variant="dark"
    backdrop
    no-header
    right
    shadow
    @hidden="$emit('hidden')"
  >
    <template #default="{ hide }">
      <div
        class="d-flex text-light align-items-center px-3 py-2"
        style="background-color: #495057"
      >
        <strong class="mr-auto">Users</strong>
        <b-button size="sm" @click="$emit('hidden')">Close</b-button>
      </div>
      <!-- <form-wizard step-size="sm" color="#556ee6">
        <tab-content title="Users" icon="mdi mdi-account-circle"> -->
      <div class="px-3 py-2">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Group in Application</h4>
                <hr />
                <!-- <p class="card-title-desc">Please select a topic.</p> -->
                <b-tabs
                  justified
                  nav-class="nav-tabs-custom"
                  content-class="p-3 text-muted"
                >
                  <b-tab active>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                      </span>
                      <span class="d-none d-sm-inline-block">From users</span>
                    </template>
                    <exist-user-tab
                      ref="existUserTab"
                      :applicationId="applicationId"
                      :groupId="groupId"
                      :groupUsers="groupUsers"
                      @getGroupUsersSelected="getGroupUsersSelected"
                      @hide="hide"
                    />
                  </b-tab>
                  <!-- <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="far fa-envelope"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">From authentication</span>
                        </template>
                        <user-authentication-tab  
                          ref="userAuthenticationTab" 
                          :applicationId="applicationId"
                          :groupId="groupId"
                          :groupUsers="groupUsers" 
                          @getGroupUsersSelected="getGroupUsersSelected" 
                          @hide="hide"
                        />
                      </b-tab> -->
                  <b-tab>
                    <template v-slot:title>
                      <span class="d-inline-block d-sm-none">
                        <i class="far fa-user"></i>
                      </span>
                      <span class="d-none d-sm-inline-block"
                        >Invite employee</span
                      >
                    </template>
                    <invite-user-tab
                      ref="inviteUserTab"
                      :applicationId="applicationId"
                      :groupId="groupId"
                      :groupUsers="groupUsers"
                      @getGroupUsersSelected="getGroupUsersSelected"
                      @hide="hide"
                    />
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-sidebar>
</template>
<script>
import Vue from "vue";
// import { FormWizard, TabContent } from "vue-form-wizard";

import groupService from "@/helpers/service/group-provider";
import userService from "@/helpers/service/user-provider";
import existUserTab from "@/components/group-user/exist-user-tab";
import inviteUserTab from "@/components/group-user/invite-user-tab";
// import attributeDefaultTab from "@/components/group-user/attribute-default-tab";
// import attributeCustomTab from "@/components/group-user/attribute-custom-tab";
import { eventBus } from "@/main.js";

import {
  StatusEnum,
  ChannelAllowEnum,
  ChannelAllowTypeEnum,
} from "@/enum/group.enum.js";
import {
  userComputed,
  userMethods,
  applicationComputed,
} from "@/state/helpers";
import ExistUserTab from "./exist-user-tab.vue";

export default {
  components: {
    "exist-user-tab": existUserTab,
    "invite-user-tab": inviteUserTab,
    // "attribute-default-tab": attributeDefaultTab,
    // "attribute-custom-tab": attributeCustomTab,
    // FormWizard,
    // TabContent,
    // "user-authentication-tab": userAuthenticationTab,
  },
  props: {
    toggleSideBar: {
      type: Boolean,
      default: false,
    },
    applicationId: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
    groupUsers: {
      type: Array,
      default: () => [],
    },
    attribute: {
      type: Object,
      default: () => ({}),
    }
  },
  data() {
    return {
      toggle: false,
    };
  },
  computed: {
    ...userComputed,
    ...applicationComputed,
  },
  watch: {
    toggleSideBar: function (val) {
      // if(val){
      //   this.onFilterUser()
      // }
       this.$refs.existUserTab.onClearData();

      this.toggle = val;
    },
  },
  methods: {
    async onFilterUser() {
      await this.$refs.existUserTab.onFilterUser();      
      await this.$refs.existUserTab.onClearData();

    },
    async getGroupUsersSelected(groupId) {
      await this.$emit("getGroupUsersSelected", groupId);
    },
  },
};
</script>
<style scope>
.vue-form-wizard .wizard-tab-content {
  padding: 0 0 5px;
}
.disabled > i,
.disabled > span {
  color: #9a9393;
}
.stepTitle {
  color: #556ee6;
}
</style>
